export const locale = {
    lang: 'en',
    data: {
        IMPORT: 'Import cards from a board',
        BOARD: 'Board',
        SELECTION: 'Selection',
        LIST: 'List',
    }
};
